import React, { useState, useEffect, useRef } from 'react';
import { FiTag, FiCheck } from 'react-icons/fi';
import axios from 'axios';
import '../../assets/css/placeholder-dropdown.css';

const PlaceholderDropdown = ({ onInsert, inputRef }) => {
    const [placeholders, setPlaceholders] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [copiedId, setCopiedId] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        fetchPlaceholders();

        // Close dropdown when clicking outside
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const fetchPlaceholders = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/placeholders', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPlaceholders(response.data);
        } catch (error) {
            console.error('Error fetching placeholders:', error);
        }
    };

    const handlePlaceholderClick = async (placeholder) => {
        try {
            // Copy to clipboard
            await navigator.clipboard.writeText(placeholder.placeholder);
            
            // Show success feedback
            setCopiedId(placeholder._id);
            
            // Close dropdown after showing feedback
            setTimeout(() => {
                setCopiedId(null);
                setIsOpen(false);
            }, 1500);
        } catch (err) {
            // Fallback for older browsers
            try {
                const textArea = document.createElement('textarea');
                textArea.value = placeholder.placeholder;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // Show success feedback
                setCopiedId(placeholder._id);
                
                // Close dropdown after showing feedback
                setTimeout(() => {
                    setCopiedId(null);
                    setIsOpen(false);
                }, 1500);
            } catch (fallbackErr) {
                console.error('Failed to copy placeholder');
                setIsOpen(false);
            }
        }
    };

    return (
        <div className="placeholder-dropdown-container" ref={dropdownRef}>
            <button
                type="button"
                className="placeholder-trigger-btn"
                onClick={() => setIsOpen(!isOpen)}
                title="Insert Placeholder"
            >
                <FiTag /> Placeholders
            </button>
            
            {isOpen && (
                <div className="placeholder-dropdown-menu">
                    <div className="placeholder-dropdown-header">
                        Insert Placeholder
                    </div>
                    {placeholders.length === 0 ? (
                        <div className="placeholder-empty">
                            No placeholders available
                        </div>
                    ) : (
                        <ul className="placeholder-dropdown-list">
                            {placeholders.map(placeholder => (
                                <li 
                                    key={placeholder._id}
                                    className={`placeholder-dropdown-item ${copiedId === placeholder._id ? 'copied' : ''}`}
                                    onClick={() => handlePlaceholderClick(placeholder)}
                                >
                                    <div className="placeholder-title">
                                        {placeholder.title}
                                        {copiedId === placeholder._id && (
                                            <span className="copied-badge">
                                                <FiCheck /> Copied!
                                            </span>
                                        )}
                                    </div>
                                    <div className="placeholder-value">{placeholder.placeholder}</div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default PlaceholderDropdown;
